import React from 'react';
import { List, Datagrid, TextField,
    EditButton, DeleteButton,
    Edit, Create, SimpleForm, TextInput,
    required, useTranslate } from 'react-admin';
import SchoolIcon from '@material-ui/icons/School';

import { EditToolbar, EditAside } from './ui_components';

const LessonGroupDeleteButton = props => {
  const translate = useTranslate();
  const confirmTitle = translate('resources.messages.delete_title', { name: `${props.record.name}` });
  const count = props.record.supervisors_count + props.record.players_count;
  const isDeletable = count === 0;
  return isDeletable && <DeleteButton {...props} undoable={false} confirmTitle={confirmTitle} />
}

const LessonGroupList = props => (
  <List {...props} bulkActionButtons={false} exporter={false} >
    <Datagrid>
        <TextField source="name" style={{ width: '100%' }}/>
        <TextField source="players_count" />
        <TextField source="supervisors_count" />
        <EditButton />
        <LessonGroupDeleteButton />
    </Datagrid>
  </List>
);

const LessonGroupEdit = props => (
  <Edit {...props} undoable={false} aside={<EditAside />}>
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput source="name" validate={[required()]} style={{ width: '100%' }}/>
    </SimpleForm>
  </Edit>
);

const LessonGroupCreate = props => (
  <Create {...props}>
    <SimpleForm redirect='list'>
      <TextInput source="name" validate={[required()]} style={{ width: '100%' }}/>
    </SimpleForm>
  </Create>
);

export default {
  list: LessonGroupList,
  create: LessonGroupCreate,
  edit: LessonGroupEdit,
  icon: SchoolIcon,
};
